import { RevalidationEvent } from "~/lib/server/revalidator";

export const revalidate = async (event: RevalidationEvent) => {
  await fetch(`/api/revalidate`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(event),
  });

  return;
};
